// auto-generated by scripts/version-info.js - do not edit, do not commit
export const versionInfo = {
  version: '1.2.3-rc',
  buildTime: '2026-09-25T04:56:36.611Z',
  timestamp: '1790312196611',
  tag: ''
};
